module.exports = __webpack_public_path__ + "static/media/detail-hd.80558add.png";